import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"
import { usePublicPresentation } from "~/containers/PublicPresentation/public-presentation-context"

import { retryLightReachRead } from "./light-reach-retry"
import type { LightReachQuoteDto } from "../dto/light-reach.dto"
import { lightReachService } from "../services/light-reach.service"

export const useGetLightReachQuote = (
  proposalId: string,
  enabled = true,
): UseQueryResult<LightReachQuoteDto | null, unknown> => {
  const presentation = usePublicPresentation()
  return useQuery<LightReachQuoteDto | null, Error>({
    queryKey: presentation
      ? queryKeys.publicPresentation.lightReach(proposalId)
      : queryKeys.lightReach.quote(proposalId),
    queryFn: () =>
      presentation
        ? Promise.resolve(presentation.lightReachQuote)
        : lightReachService.getQuote(proposalId),
    initialData: presentation?.lightReachQuote,
    enabled: !presentation && enabled && !!proposalId,
    retry: retryLightReachRead,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
}
